import { WebClientResponseHelper, WebClientResponse } from '../requester/webClientResponse';
import { WebClientApiResponse, WebClientApiResult, WebClientApiErrorResult } from './WebClientApiResponse';
import { WebClientApiError } from './WebClientApiError';

export function isResultWithErrors<T>(result: T | WebClientApiErrorResult): result is WebClientApiErrorResult {
  return !!(<WebClientApiErrorResult> result).errors;
}

export function getErrors(res: WebClientApiResponse<WebClientApiResult>): WebClientApiError[] {
  return isResultWithErrors(res.result) ? res.result.errors : [];
}

export function getSuccessResult<TResult>(response: WebClientResponse<WebClientApiResponse<TResult>>): PromiseLike<TResult> {
  if (WebClientResponseHelper.isErrorResponse(response)) {
    return Promise.reject(response);
  }

  let result = response.response.result;
  if (isResultWithErrors(result)) {
    return Promise.reject(response);
  }

  return Promise.resolve(result);
}
